import TrainingAttendance from '../attendance';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingAttendance.destroy(({ trainingId, sessionId, lessonId, attendanceId }, fetch) => {
    return fetch.delete(`/trainings/${trainingId}/sessions/${sessionId}/lessons/${lessonId}/attendances/${attendanceId}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };